/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CampaignsDataType } from "../../type";
import { useQuery } from "react-query";
import { SMSCampaignList } from "../../Api";
import { AxiosResponse } from "axios";
import { FaEye } from "react-icons/fa";
import { RenderPaginationButtons } from "../../../Components/Paginations";

interface PropsType {
    RedirectURL: string,
    ReportTitle: string
}

export default function ReportCampaignList({ RedirectURL, ReportTitle }: PropsType) {
    const [campaigns, setCampaigns] = useState<CampaignsDataType[]>([]);
    const [search] = useState("");
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [page, setPage] = useState(1);
    const navigate = useNavigate();

    const { refetch } = useQuery({
        queryKey: ["Campaign_List", page, search],
        queryFn: SMSCampaignList,
        onSuccess: (resp: AxiosResponse) => {
            setIsLoading(false);
            setIsFirstLoad(false);
            setCampaigns(resp.data?.data || []);
            setPage(resp.data?.info?.current_page || 1);
            setInfo(resp?.data?.info);
        },
        enabled: false,
    });

    useEffect(() => {
        refetch();
    }, [page]);

    useEffect(() => {
        if (isFirstLoad) return;
        setIsLoading(true);
        let debounce = setTimeout(() => {
            refetch()
        }, 300)

        return () => {
            clearTimeout(debounce);
        }
    }, [search]);
    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
        }
    };

    return (
        <div className="container-fluid">
            <div className="card mt-4">
                <div className="card-header bg-white p-3 d-md-flex justify-content-md-between align-items-center">
                    <h2 className="w-100 mb-md-2 mb-3">{ReportTitle}</h2>
                </div>
                <div className="card-body  p-0">
                    <div className="table-responsive">
                        <table className="table table-hover table-bordered text-nowrap">
                            <thead>
                                <tr>
                                    <th className="ps-3 sr-no">SR No</th>
                                    <th>Name</th>
                                    <th className="text-center action">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={3} height={100}>
                                            <div className="text-center">
                                                <div className="loader"></div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : campaigns.length !== 0 ? (
                                    campaigns.map((item, i) => (
                                        <tr key={i}>
                                            <td> {i + 1}</td>
                                            <td>{item?.name}</td>
                                            <td>
                                                <div className="w-100 d-flex justify-content-center">
                                                    <FaEye
                                                        className="h4 mb-0 cursor-pointer text-success"
                                                        onClick={() =>
                                                            navigate(RedirectURL, { state: { id: item?.id } })
                                                        }
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} className="text-center">
                                            No Data Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {info && info.total_page ? (
                        <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                            <RenderPaginationButtons
                                info={info}
                                currentPage={page}
                                handlePageChange={handlePageChange}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};